<div class="wrapper-popover" [@fadeInOnEnter] [@fadeOutOnLeave]>
    <h2 class="box-title">
      Terms and Conditions
    </h2>
    <div class="tnc-box" [innerHTML]="data"></div>
    <div class="button-box fixed">
      <app-main-button
        (onClick)="onPopOverDecline()"
        [buttonWidth]="'40vw'"
        [border]="'1px solid #000000'"
        [textColor]="'#000000'"
        [backgroundColor]="'#FFFFFF'"
        [buttonText]="'Decline'">
      </app-main-button>
      <app-main-button
        (onClick)="onPopOverAccept()"
        [buttonWidth]="'40vw'"
        [border]="'1px solid #000000'"
        [textColor]="'#FFFFFF'"
        [backgroundColor]="'#000000'"
        [buttonText]="'Accept'">
      </app-main-button>
    </div>
  </div>